import React from "react";
import { BiUser } from "react-icons/bi";
import { FaRegRegistered } from "react-icons/fa";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { RiCalendarCheckLine, RiCalendarTodoLine } from "react-icons/ri";

const UserDetails = () => {
  return (
    <div>
      <div className="flex items-center gap-3">
        <BiUser className="h-5 w-5 text-primary" />
        <span className="relative pr-1 font-pop text-base font-medium text-black opacity-70">
          Ben88
          <span className="absolute -top-1 left-full  font-pop text-[13px] font-medium text-secondary ">
            425
          </span>
        </span>
      </div>
      <div className="flex items-center gap-3">
        <FaRegRegistered className="h-5 w-5 text-primary" />
        <span className="font-pop text-base font-medium text-black opacity-70">
          Registered
        </span>
      </div>
      <div className="flex items-center gap-3">
        <HiOutlineLocationMarker className="h-5 w-5 text-primary" />
        <span className="font-pop text-base font-medium text-black opacity-70">
          Northern Cape
        </span>
      </div>
      <div className="flex items-center gap-3">
        <RiCalendarCheckLine className="h-5 w-5 text-primary" />
        <span className="font-pop text-base font-medium text-black opacity-70">
          User & Email Verified
        </span>
      </div>
      <div className="flex items-center gap-3">
        <RiCalendarTodoLine className="h-5 w-5 text-primary" />
        <span className="font-pop text-base font-medium text-black opacity-70">
          Joined 9 Sep 2019
        </span>
      </div>
    </div>
  );
};

export default UserDetails;
